import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DeleteConfirmDialogData } from './delete-confirm-dialog-data';
import { DeleteConfirmDialogComponent } from './delete-confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class DeleteConfirmDialogService {
  private readonly dialog: MatDialog = inject(MatDialog);

  open(dialogData: DeleteConfirmDialogData): MatDialogRef<DeleteConfirmDialogComponent, boolean> {
    return this.dialog.open<DeleteConfirmDialogComponent, DeleteConfirmDialogData, boolean>(
      DeleteConfirmDialogComponent,
      {
        data: dialogData,
        panelClass: 'mp-delete-confirm-dialog-container',
      },
    );
  }
}
